import { Link, useLocation } from 'react-router-dom';
import { BASE } from '../../basePath';

/** The three sub-pages of the Monitoring section, in tab order. */
const TABS = [
    { to: `${BASE}/backOffice/monitoring/field`, label: 'Field' },
    // Devices kept at the office, for development and pre-production testing.
    { to: `${BASE}/backOffice/monitoring/bench`, label: 'Bench' },
    { to: `${BASE}/backOffice/monitoring/settings`, label: 'Settings' },
];

/** Sub-navigation between the two monitoring grids and their shared settings. */
export default function MonitoringTabs() {
    const { pathname } = useLocation();
    return (
        <div className="flex gap-1 mb-6 border-b border-[#1e242a]">
            {TABS.map((tab) => {
                // The three are siblings, so an exact match is all it takes.
                const active =
                    pathname === tab.to || pathname === tab.to + '/';
                return (
                    <Link
                        key={tab.to}
                        to={tab.to}
                        className={`px-4 py-2 text-sm -mb-px border-b-2 transition ${
                            active
                                ? 'border-[#74c69d] text-white'
                                : 'border-transparent text-[#a8b0bb] hover:text-white'
                        }`}
                    >
                        {tab.label}
                    </Link>
                );
            })}
        </div>
    );
}
